import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['You are a practicing High School Chemistry teacher', 'You want lessons that are structured, visual and ready to use', 'You want a complete system — not more content to organize', 'You want students genuinely engaged — not just sitting quietly', 'You teach in-person, hybrid, or online', 'You want your classroom to look and feel more professional'];
const notForYou = ['You are looking for a video course or academic certification.', 'You prefer to create every classroom resource entirely from scratch.', 'You need a fully customized curriculum designed specifically for your school.', 'You are looking for live tutoring, coaching, or ongoing teaching support.'];
export function AudienceSection() {
  return <section className="w-full bg-paper px-5 py-12 sm:py-20" data-id="element-10" data-mp="3cqk0wr69orqz">
      <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2" data-id="element-11" data-mp="3hov8ev93aq61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border border-cobalt/20 bg-[#EEF4FF] p-6 sm:p-8" data-id="element-12" data-mp="14aj874f6ix1m">
          <h3 className="mb-6 text-lg font-bold text-cobalt-deep sm:text-xl" data-id="element-13" data-mp="qje49q4s3ilh">
            ✅ This is for you if...
          </h3>
          <ul className="space-y-4" data-id="element-14" data-mp="lkl04obdt3xz">
            {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-15" data-mp="glhtx0jo0rof">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-16" data-mp="gjwzdaxcp8qk">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-17" data-mp="7ktgo823ivcl" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80" data-id="element-18" data-mp="25zwer9rkbuen">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="rounded-2xl border border-red-100 bg-[#FFF5F5] p-6 sm:p-8" data-id="element-19" data-mp="21z2r8hi18hma">
          <h3 className="mb-6 text-lg font-bold text-ink sm:text-xl" data-id="element-20" data-mp="3mi6j3gm1r78r">
            ❌ This is not for you if...
          </h3>
          <ul className="space-y-4" data-id="element-21" data-mp="3qg45kbofnf8g">
            {notForYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-22" data-mp="i2x2gd3obdhj">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-23" data-mp="n1qes2784yg4">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-24" data-mp="9176ctyujqdf" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80" data-id="element-25" data-mp="dz8qli80dvqh">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}